import FormField from '@sportnet/ui/lib/FormField/redux-form';
import * as React from 'react';
import { Field } from 'redux-form';
import { FormField as IFormSegmentElement } from '../../../api';

interface OwnProps {
  data: IFormSegmentElement;
  name: string;
}

const DateInputFormElement: React.FC<OwnProps> = ({ data, name }) => (
  <Field
    readOnly
    type="date"
    name={name}
    component={FormField}
    label={data.label}
  />
);

export default DateInputFormElement;
